import { render, staticRenderFns } from "./Decoration.vue?vue&type=template&id=4aaaa855&scoped=true"
import script from "./Decoration.vue?vue&type=script&lang=js"
export * from "./Decoration.vue?vue&type=script&lang=js"
import style0 from "./Decoration.vue?vue&type=style&index=0&id=4aaaa855&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaaa855",
  null
  
)

export default component.exports